import { WALLET_NUA_EXPIRING_SOON_DAYS } from '../WalletAwardsSection.constants';

export { WALLET_NUA_EXPIRING_SOON_DAYS };

export const isWalletAwardExpiringSoon = (
  expirationDate: string | undefined,
  thresholdDays: number = WALLET_NUA_EXPIRING_SOON_DAYS
): boolean => {
  if (!expirationDate || !Number.isFinite(thresholdDays)) {
    return false;
  }

  const expirationTime = new Date(expirationDate).getTime();
  if (Number.isNaN(expirationTime)) {
    return false;
  }

  const daysUntil = (expirationTime - Date.now()) / (1000 * 60 * 60 * 24);
  return daysUntil >= 0 && daysUntil <= thresholdDays;
};
